module.exports = __webpack_public_path__ + "static/the-macintosh-way-cfbbb6be89580339a6bcfb777bfa84ce.jpg";